export const serviceBooksWithPlays = [
  {
    name: 'sb1',
    id: 'sb1',
    plays: [
      {
        name: 'play415 1',
        id: 'play11',
        play: {
          services: [],
          advisor: null,
          transportation: 4,
        },
        filterRules: [
          {
            type: 'Days From Last No Show Appointment',
            operator: 'Equal',
            value: '1',
            isCriteria: true,
          },
        ],
        communicationDetails: {
          textMessage: 'Hello, this is a test message.',
        },
        triggers: [],
        active: true,
        activeText: 'CUstive text',
      },
      {
        name: 'play 3212',
        id: 'play2312',
        play: {
          services: ['157', '15122'],
          advisor: null,
          transportation: 4,
        },
        filterRules: [],
        communicationDetails: {
          textMessage: 'Hello, this is a test message.',
        },
        triggers: [],
        active: false,
        activeText: 'CUstive text',
      },
    ],
  },
  {
    name: 'sb2',
    id: 'sb2',
    plays: [
      {
        name: 'play 132211',
        id: 'play131231',
        play: {
          services: ['157', '15122'],
          advisor: null,
          transportation: 4,
        },
        filterRules: [],
        communicationDetails: {
          textMessage: 'Hello, this is a test message.',
        },
        triggers: [],
        active: true,
        activeText: 'CUstive text',
      },
      {
        name: 'play23423 2',
        id: 'play24324',
        play: {
          services: ['157', '15122'],
          advisor: null,
          transportation: 4,
        },
        filterRules: [],
        communicationDetails: {
          textMessage: 'Hello, this is a test message.',
        },
        triggers: [],
        active: false,
        activeText: 'CUstive text',
      },
      {
        name: 'play23423 2',
        id: 'play2432321314',
        play: {
          services: ['157', '15122'],
          advisor: null,
          transportation: 5,
        },
        filterRules: [],
        communicationDetails: {
          textMessage: 'Hello, this is a test message.',
        },
        triggers: [],
        active: false,
        activeText: 'CUstive text',
      },
      {
        name: 'play23423 2',
        id: 'play24323213114',
        play: {
          services: ['157', '15122'],
          advisor: null,
          transportation: 5,
        },
        filterRules: [],
        communicationDetails: {
          textMessage: 'Hello, this is a test message.',
        },
        triggers: [],
        active: false,
        activeText: 'CUstive text',
      },
      {
        name: 'play23423 2',
        id: 'play243231221314',
        play: {
          services: ['157', '15122'],
          advisor: null,
          transportation: 5,
        },
        filterRules: [],
        communicationDetails: {
          textMessage: 'Hello, this is a test message.',
        },
        triggers: [],
        active: false,
        activeText: 'CUstive text',
      },
      {
        name: 'play23423 2',
        id: 'play243132321314',
        play: {
          services: ['157', '15122'],
          advisor: null,
          transportation: 5,
        },
        filterRules: [],
        communicationDetails: {
          textMessage: 'Hello, this is a test message.',
        },
        triggers: [],
        active: false,
        activeText: 'CUstive text',
      },
      {
        name: 'play23423 2',
        id: 'pl11ay2432321314',
        play: {
          services: ['157', '15122'],
          advisor: null,
          transportation: 5,
        },
        filterRules: [],
        communicationDetails: {
          textMessage: 'Hello, this is a test message.',
        },
        triggers: [],
        active: false,
        activeText: 'CUstive text',
      },
      {
        name: 'play23423 2',
        id: 'play24331162321314',
        play: {
          services: ['157', '15122'],
          advisor: null,
          transportation: 5,
        },
        filterRules: [],
        communicationDetails: {
          textMessage: 'Hello, this is a test message.',
        },
        triggers: [],
        active: false,
        activeText: 'CUstive text',
      },
      {
        name: 'play23123423 2',
        id: 'play24323213j4',
        play: {
          services: ['157', '15122'],
          advisor: null,
          transportation: 5,
        },
        filterRules: [],
        communicationDetails: {
          textMessage: 'Hello, this is a test message.',
        },
        triggers: [],
        active: false,
        activeText: 'CUstive text',
      },
    ],
  },
];
